const evEnums = {
  CREDITS: {
    FeatureType: {
      PLAN: {
        Name: "PLAN",
        Label: "Plan",
      },
      COMPANY: {
        Name: "COMPANY",
        Label: "Compañia",
      },
    },
    TransactionType: {
      DEBIT: {
        Name: "DEBIT",
        Label: "DÉBITO",
      },
      CREDIT: {
        Name: "CREDIT",
        Label: "ACREDITACIÓN",
      },
      OVERDRAW: {
        Name: "OVERDRAW",
        Label: "SOBREGIRO",
      },
      PAY_OVERDRAW: {
        Name: "PAY_OVERDRAW",
        Label: "PAGO SOBREGIRO",
      },
    },
    TypeClient: {
      PERSON: {
        Name: "PERSON",
        Label: "Persona",
      },
      COMPANY: {
        Name: "COMPANY",
        Label: "Compañia",
      },
    },
    TypePersonPlan: {
      PROCESS: {
        Name: "PROCESS",
        Label: "PROCESS",
      },
    },
    TypeReference: {
      PROCESS: {
        Name: "PROCESS",
        Label: "Proceso",
      },
      PERSON: {
        Name: "PERSON",
        Label: "Persona",
      },
      PAY_PAL: {
        Name: "PAY_PAL",
        Label: "Paypal",
      },
      KUSHKI: {
        Name: "KUSHKI",
        Label: "Kuski",
      },
    },
    Periodicity: {
      WEEKLY: {
        Name: "WEEKLY",
        Label: "SEMANALMENTE",
      },
      MONTHLY: {
        Name: "MONTHLY",
        Label: "MENSUALMENTE",
      },
      QUARTERLY: {
        Name: "QUARTERLY",
        Label: "TRIMESTRALMENTE",
      },
      BIANNUALLY: {
        Name: "BIANNUALLY",
        Label: "SEMESTRALMENTE",
      },
      ANNUALLY: {
        Name: "ANNUALLY",
        Label: "ANUALMENTE",
      },
    },
    PlanLevelType: {
      PRIMARY: {
        Name: "PRIMARY",
        Label: "PRIMARIO",
      },
      SECONDARY: {
        Name: "SECONDARY",
        Label: "SECUNDARIA",
      },
    },
    StateOrder: {
      PENDING: {
        Name: "PENDING",
        Label: "Pendiente",
      },
      PAID: {
        Name: "PAID",
        Label: "Pagada",
      },
      CANCELED: {
        Name: "CANCELED",
        Label: "Cancelada",
      },
      EXPIRED: {
        Name: "EXPIRED",
        Label: "Expirada",
      },
    },
    TypeCompanyPlan: {
      CREDIT: {
        Name: "CREDIT",
        Label: "CREDITOS",
      },
      PROCESS: {
        Name: "PROCESS",
        Label: "PROCESO",
      },
      FREEMIUM: {
        Name: "FREEMIUM",
        Label: "FREEMIUM",
      },
      USER: {
        Name: "USER",
        Label: "USUARIOS",
      },
      TALENT_POOL: {
        Name: "TALENT_POOL",
        Label: "TALENT POOL",
      },
      RELIABILITY: {
        Name: "RELIABILITY",
        Label: "CONFIABILIDAD",
      },
      VERIFIER: {
        Name: "VERIFIER",
        Label: "VERIFICANTE",
      },
      COPILOT_AI: {
        Name: "COPILOT_AI",
        Label: "COPILOT AI",
      },
      HIRING_MANAGER: {
        Name: "HIRING_MANAGER",
        Label: "REQUISICIÓN DE VACANTES",
      },
    },
    PlanStatus: {
      ACTIVE: {
        Name: "ACTIVE",
        Label: "ACTIVO",
      },
      INACTIVE: {
        Name: "INACTIVE",
        Label: "INACTIVO",
      },
      EXPIRED: {
        Name: "EXPIRED",
        Label: "EXPIRADO",
      },
      CANCELLED: {
        Name: "CANCELLED",
        Label: "CANCELADO",
      },
    },
  },
  MODULE: {
    SystemModule: {
      CREDITS: {
        Name: "CREDITS",
        Label: "CRÉDITOS",
      },
    },
  },
  QAE: {
    QuestionAttributeType: {
      STATEMENT: {},
      SCENERY: {},
    },
    Type: {
      SINGLE: {
        Abbreviation: "SIMPLE",
        Active: true,
        Name: "SINGLE",
        Label: "SELECCIÓN SIMPLE",
      },
      MULTIPLE: {
        Abbreviation: "MULTIPLE",
        Active: true,
        Name: "MULTIPLE",
        Label: "SELECCIÓN MULTIPLE",
      },
      SHORT_TEXT: {
        Abbreviation: "ST",
        Active: false,
        Name: "SHORT_TEXT",
        Label: "TEXTO CORTO",
      },
      MEDIUM_TEXT: {
        Abbreviation: "MT",
        Active: false,
        Name: "MEDIUM_TEXT",
        Label: "TEXTO MEDIANO",
      },
      LARGE_TEXT: {
        Abbreviation: "LT",
        Active: false,
        Name: "LARGE_TEXT",
        Label: "TEXTO LARGO",
      },
      MULTIPLE_TEXT: {
        Abbreviation: "MT",
        Active: false,
        Name: "MULTIPLE_TEXT",
        Label: "TEXTO MULTIPLE",
      },
      VIDEO: {
        Abbreviation: "VIDEO",
        Active: false,
        Name: "VIDEO",
        Label: "VIDEO",
      },
      FILE: {
        Abbreviation: "FILE",
        Active: true,
        Name: "FILE",
        Label: "FILE",
      },
      MATRIX: {
        Abbreviation: "MATRIX",
        Active: true,
        Name: "MATRIX",
        Label: "MATRICIAL",
      },
    },
    QuestionDifficulty: {
      EASY: {
        Difficulty: "BAJA",
        ComplexValue: 2,
        Name: "EASY",
        Label: "BAJA",
      },
      MEDIUM: {
        Difficulty: "MEDIA",
        ComplexValue: 4,
        Name: "MEDIUM",
        Label: "MEDIA",
      },
      HARD: {
        Difficulty: "ALTA",
        ComplexValue: 6,
        Name: "HARD",
        Label: "ALTA",
      },
    },
    Selector: {
      RADIO: {},
      CHECKBOX: {},
    },
    Indicator: {
      KEYWORDS: {},
      ARCHETYPE: {},
    },
    EntityCodesEnum: {
      PROFILE: {
        Name: "PROFILE",
        Label: "PROFILE",
      },
      QUESTION: {
        Name: "QUESTION",
        Label: "QUESTION",
      },
      ANSWER: {
        Name: "ANSWER",
        Label: "ANSWER",
      },
      COMPANY: {
        Name: "COMPANY",
        Label: "COMPANY",
      },
      GAP_RESULT: {
        Name: "GAP_RESULT",
        Label: "GAP_RESULT",
      },
      QUESTION_BANK: {
        Name: "QUESTION_BANK",
        Label: "QUESTION_BANK",
      },
      PROCESS: {
        Name: "PROCESS",
        Label: "PROCESS",
      },
      FILE: {
        Name: "FILE",
        Label: "FILE",
      },
    },
    TestDifficulty: {
      EASY: {
        Difficulty: "BAJA",
        ComplexValue: 2,
        Name: "EASY",
        Label: "BAJA",
      },
      MEDIUM: {
        Difficulty: "MEDIA",
        ComplexValue: 4,
        Name: "MEDIUM",
        Label: "MEDIA",
      },
      HARD: {
        Difficulty: "ALTA",
        ComplexValue: 6,
        Name: "HARD",
        Label: "ALTA",
      },
      CUSTOM: {
        Difficulty: "PERSONALIZADA",
        ComplexValue: 8,
        Name: "CUSTOM",
        Label: "PERSONALIZADA",
      },
    },
    ContentType: {
      HTML: {
        Name: "HTML",
        Label: "HTML",
      },
      TEXT: {
        Name: "TEXT",
        Label: "TEXTO",
      },
      IMAGE: {
        Name: "IMAGE",
        Label: "IMAGEN",
      },
      VIDEO: {
        Name: "VIDEO",
        Label: "VIDEO",
      },
      FILE: {
        Name: "FILE",
        Label: "ARCHIVO",
      },
    },
  },
  PROCESS: {
    EnvironmentType: {
      EMAIL: {
        Name: "EMAIL",
        Label: "CORREO",
      },
      CONTROLLED: {
        Name: "CONTROLLED",
        Label: "CONTROLADO",
      },
    },
    ProductType: {
      CAP: {
        Name: "CAP",
        Label: "CAP",
      },
      KNOWLEDGE: {
        Name: "KNOWLEDGE",
        Label: "CONOCIMIENTO",
      },
      CURRICULUM: {
        Name: "CURRICULUM",
        Label: "CURRICULUM",
      },
      INTERVIEW: {
        Name: "INTERVIEW",
        Label: "VIDEO ENTREVISTA",
      },
      DISC: {
        Name: "DISC",
        Label: "DISC",
      },
      EVALUATION_360: {
        Name: "EVALUATION_360",
        Label: "360",
      },
      QUESTION_FILTER: {
        Name: "QUESTION_FILTER",
      },
      ALL: {
        Name: "ALL",
        Label: "TODOS",
      },
    },
    ProcessActionEnum: {
      BULK_REMINDER_NOTIFICATION: {
        Name: "BULK_REMINDER_NOTIFICATION",
      },
    },
    JobPortal: {
      LINKEDIN: {
        Name: "LINKEDIN",
        Label: "Linkedin",
      },
      GOOGLE_JOBS: {
        Name: "GOOGLE_JOBS",
        Label: "Google jobs",
      },
      INDEED: {
        Name: "INDEED",
        Label: "Indeed",
      },
      GLASSDOOR: {
        Name: "GLASSDOOR",
        Label: "Glassdoor",
      },
      JOOBLE: {
        Name: "JOOBLE",
        Label: "Jooble",
      },
      TROVIT: {
        Name: "TROVIT",
        Label: "Trovit",
      },
      MITULA: {
        Name: "MITULA",
        Label: "Mitula",
      },
      BUSCOJOBS: {
        Name: "BUSCOJOBS",
        Label: "Buscojobs",
      },
      OPCIONEMPLEO: {
        Name: "OPCIONEMPLEO",
        Label: "Opcionempleo",
      },
      TALENT: {
        Name: "TALENT",
        Label: "Talent",
      },
      CLICKJOB: {
        Name: "CLICKJOB",
        Label: "Clickjob",
      },
    },
    ProcessPaymentTypeEnum: {
      CLIENT: {
        Name: "CLIENT",
        Label: "Cliente",
      },
      EVALUATED: {
        Name: "EVALUATED",
        Label: "Evaluado",
      },
      BOTH: {
        Name: "BOTH",
        Label: "Compartido",
      },
      DEFERRED_EVALUATED: {
        Name: "DEFERRED_EVALUATED",
        Label: "Evaluado diferido",
      },
      FREEMIUM: {
        Name: "FREEMIUM",
        Label: "freemium",
      },
    },
    JobTemporality: {
      FULL_TIME: {
        Name: "FULL_TIME",
        Label: "Tiempo Completo",
      },
      TEMPORARY: {
        Name: "TEMPORARY",
        Label: "Temporal",
      },
      MIDDLE_TIME: {
        Name: "MIDDLE_TIME",
        Label: "Medio Tiempo",
      },
    },
    SystemVariableValue: {
      MAX_RELAUNCH_ALLOWED: {
        Name: "MAX_RELAUNCH_ALLOWED",
        Label: "Relanzamientos mÃ¡ximos permitidos",
      },
      MAX_AGE_FOR_RELAUNCH: {
        Name: "MAX_AGE_FOR_RELAUNCH",
        Label: "Edad mÃ¡xima para relanzamiento",
      },
      MAX_DURATION_OF_LAUNCH: {
        Name: "MAX_DURATION_OF_LAUNCH",
        Label: "DuraciÃ³n de lanzamiento",
      },
      DURATION_AFTER_PUBLICATION: {
        Name: "DURATION_AFTER_PUBLICATION",
        Label: "DuraciÃ³n de publicaciÃ³n",
      },
      MAX_RELAUNCH_ALLOWED_NO_LONG_DURATION: {
        Name: "MAX_RELAUNCH_ALLOWED_NO_LONG_DURATION",
      },
    },
    ExternalSite: {
      JOB_BOARD: {
        Active: true,
        HasProvider: false,
        Name: "JOB_BOARD",
        Label: "Job Board (Obsoleto)",
      },
      MULTI_TRABAJOS: {
        Active: true,
        MultipostingCode: "00001",
        HasProvider: false,
        Name: "MULTI_TRABAJOS",
        Label: "Multitrabajos",
      },
      JOB_BOARD_V2: {
        Active: true,
        HasProvider: false,
        Name: "JOB_BOARD_V2",
        Label: "Job Board",
      },
      OCC: {
        Active: true,
        MultipostingCode: "00002",
        HasProvider: false,
        Name: "OCC",
        Label: "Occ",
      },
      COMPU_TRABAJO: {
        Active: false,
        MultipostingCode: "00003",
        HasProvider: false,
        Name: "COMPU_TRABAJO",
        Label: "Computrabajo",
      },
      EXTERNAL_PROVIDER: {
        Active: true,
        MultipostingCode: "00004",
        HasProvider: true,
        Name: "EXTERNAL_PROVIDER",
        Label: "Proveedor Externo",
      },
      KONZERTA: {
        Active: true,
        MultipostingCode: "00005",
        HasProvider: false,
        Name: "KONZERTA",
        Label: "Konzerta",
      },
      TRABAJOPOLIS: {
        Active: true,
        MultipostingCode: "00006",
        HasProvider: false,
        Name: "TRABAJOPOLIS",
        Label: "Trabajopolis",
      },
      TECOLOCO_GT: {
        Active: true,
        MultipostingCode: "00007",
        HasProvider: false,
        Name: "TECOLOCO_GT",
        Label: "Tecoloco Guatemala",
      },
    },
    EventProvider: {
      CREATE: {
        Name: "CREATE",
        Label: "Crear",
      },
      UPDATE: {
        Name: "UPDATE",
        Label: "Actualizar",
      },
      DELETE: {
        Name: "DELETE",
        Label: "Eliminar",
      },
    },
    PeriodicitySummary: {
      DAILY: {
        Name: "DAILY",
        Label: "DIARIAMENTE",
      },
      MONTHLY: {
        Name: "MONTHLY",
        Label: "MENSUALMENTE",
      },
      QUARTERLY: {
        Name: "QUARTERLY",
        Label: "TRIMESTRALMENTE",
      },
      ANNUALLY: {
        Name: "ANNUALLY",
        Label: "ANUALMENTE",
      },
    },
    Feeling: {
      YES: {
        Name: "YES",
        Order: 1,
        Label: "Me gusta",
      },
      NO: {
        Name: "NO",
        Order: 3,
        Label: "No me gusta",
      },
      MAYBE: {
        Name: "MAYBE",
        Order: 2,
        Label: "Tal vez",
      },
    },
    ProcessStatus: {
      DRAFT: {
        Name: "DRAFT",
        Label: "BORRADOR",
      },
      LAUNCHED: {
        Name: "LAUNCHED",
        Label: "EN PROGRESO",
      },
      CLOSED: {
        Name: "CLOSED",
        Label: "CERRADO",
      },
      CANCELED: {
        Name: "CANCELED",
        Label: "CANCELADO",
      },
    },
    SystemVariableCategory: {
      PROCESS_RELAUNCH: {
        Name: "PROCESS_RELAUNCH",
        Label: "Relanzamiento del proceso",
      },
    },
    ReliabilityProductType: {
      RELIABILITY: {
        Name: "RELIABILITY",
      },
      SAFER: {
        Name: "SAFER",
      },
    },
    JobModality: {
      VIRTUAL: {
        Name: "VIRTUAL",
        Label: "Virtual",
      },
      IN_PERSON: {
        Name: "IN_PERSON",
        Label: "Presencial",
      },
      HYBRID: {
        Name: "HYBRID",
        Label: "Híbrido",
      },
      INDIFFERENT: {
        Name: "INDIFFERENT",
        Label: "Indiferente",
      },
    },
    PublicProcessTag: {
      NEW_PERSON: {
        Name: "NEW_PERSON",
        Label: "new_person",
      },
      NEW_FREEMIUM_PERSON: {
        Name: "NEW_FREEMIUM_PERSON",
        Label: "new_freemium_person",
      },
      ALREADY_BOUGHT: {
        Name: "ALREADY_BOUGHT",
        Label: "already_bought",
      },
      ENDED_OBSERVER_PERSON: {
        Name: "ENDED_OBSERVER_PERSON",
        Label: "ended_observer_person",
      },
      ENDED_PERSON: {
        Name: "ENDED_PERSON",
        Label: "ended_person",
      },
      DISQUALIFIED_PERSON: {
        Name: "DISQUALIFIED_PERSON",
        Label: "disqualified_person",
      },
      IN_PROGRESS_PERSON: {
        Name: "IN_PROGRESS_PERSON",
        Label: "in_progress_person",
      },
    },
    ExternalProvider: {
      TRABAJANDO: {
        Active: true,
        Name: "TRABAJANDO",
        Label: "Trabajando",
      },
      BOLSA_EMPLEO_CHILE: {
        Active: true,
        Name: "BOLSA_EMPLEO_CHILE",
        Label: "Bolsa de empleo Chile",
      },
      HCM: {
        Active: true,
        Name: "HCM",
        Label: "HCM",
      },
      LAPZO_DO: {
        Active: true,
        Name: "LAPZO_DO",
        Label: "Lapzo Desarrollo Organizacional",
      },
      BUK: {
        Active: true,
        Name: "BUK",
        Label: "BUK",
      },
    },
    ProcessPersonStatus: {
      OPEN: {
        Finished: false,
        Name: "OPEN",
        Order: 3,
        Label: "SIN INICIAR",
      },
      INPROGRESS: {
        Finished: false,
        Name: "INPROGRESS",
        Order: 2,
        Label: "EN PROGRESO",
      },
      ENDED: {
        Finished: true,
        Name: "ENDED",
        Order: 1,
        Label: "TERMINADO",
      },
      DISQUALIFIED: {
        Finished: true,
        Name: "DISQUALIFIED",
        Order: 4,
        Label: "DESCALIFICADO",
      },
    },
    SourceEnum: {
      CAP_ADDED: {
        Name: "CAP_ADDED",
      },
      TALENT_POOL: {
        Name: "TALENT_POOL",
      },
      OCC: {
        Name: "OCC",
      },
      MULTITRABAJOS: {
        Name: "MULTITRABAJOS",
      },
      EMPLEOYA: {
        Name: "EMPLEOYA",
      },
      COMPUTRABAJOS: {
        Name: "COMPUTRABAJOS",
      },
      TRANSDOC: {
        Name: "TRANSDOC",
      },
      TECOLOCO: {
        Name: "TECOLOCO",
      },
      CHILE_TRABAJOS: {
        Name: "CHILE_TRABAJOS",
      },
      EMPLEO_NUEVO: {
        Name: "EMPLEO_NUEVO",
      },
      ALDABA: {
        Name: "ALDABA",
      },
      INDEED: {
        Name: "INDEED",
      },
      EL_EMPLEO: {
        Name: "EL_EMPLEO",
      },
      SHERLOCK: {
        Name: "SHERLOCK",
      },
      TRABAJANDO_CHILE: {
        Name: "TRABAJANDO_CHILE",
      },
    },
  },
  AUTH: {
    ErrorMessages: {
      PERSON_ALREADY_EXISTS_IN_PROCESS: {
        Name: "PERSON_ALREADY_EXISTS_IN_PROCESS",
        Label: "La persona ya existe en el proceso",
      },
    },
  },
  SECURITY: {
    RoleType: {
      EVALUAR: {},
      CLIENT: {},
      SYSTEM: {},
      FREEMIUM: {},
    },
    RealmEnum: {
      EVCORE: {
        Name: "EVCORE",
        Label: "evcore",
        RealmName: "evcore",
      },
      EVBASIC: {
        Name: "EVBASIC",
        Label: "evbasic",
        RealmName: "evbasic",
      },
      MASTER: {
        Name: "MASTER",
        Label: "master",
        RealmName: "master",
      },
      EVEXTERNAL: {
        Name: "EVEXTERNAL",
        Label: "evexternal",
        RealmName: "evexternal",
      },
    },
  },
  CATALOGS: {
    RelatedCatalogs: {
      INDUSTRY: {
        Name: "INDUSTRY",
        Label: "Industria",
      },
      SUB_AREA: {
        Name: "SUB_AREA",
        Label: "Sub área",
      },
      FIELD_STUDY: {
        Name: "FIELD_STUDY",
        Label: "Campo de Estudio",
      },
      AREA: {
        Name: "AREA",
        Label: "Area",
      },
    },
  },
  EVALUATION: {
    PersonResultsErrorEnum: {
      NOT_PAYED: {
        Name: "NOT_PAYED",
        Label: "NO PAGADO",
      },
    },
    CapReportSectionEnum: {
      INTRO: {
        Name: "INTRO",
        Order: 0,
        Label: "Resumen ejecutivo/CAP",
      },
      COMPETENCES: {
        Name: "COMPETENCES",
        Order: 1,
        Label: "Competencias",
      },
      GAP: {
        Name: "GAP",
        Order: 2,
        Label: "Brechas",
      },
      FACTORS: {
        Name: "FACTORS",
        Order: 3,
        Label: "Evaluaciones",
      },
      KNOWLEDGE_INTRO: {
        Name: "KNOWLEDGE_INTRO",
        Order: 4,
        Label: "Intro Conocimiento",
      },
      KNOWLEDGE_QUESTIONS: {
        Name: "KNOWLEDGE_QUESTIONS",
        Order: 5,
        Label: "Preguntas Conocimiento",
      },
      CURRICULUM: {
        Name: "CURRICULUM",
        Order: 6,
        Label: "Curriculum",
      },
      INTERVIEW: {
        Name: "INTERVIEW",
        Order: 7,
        Label: "Entrevista",
      },
      FILTER_QUESTIONS: {
        Name: "FILTER_QUESTIONS",
        Order: 8,
        Label: "Preguntas Filtro",
      },
      COMPETENCE_QUESTION: {
        Name: "COMPETENCE_QUESTION",
        Order: 9,
        Label: "Preguntas de competencias",
      },
      DISC: {
        Name: "DISC",
        Order: 10,
        Label: "DISC",
      },
      DISC_ADVANCED: {
        Name: "DISC_ADVANCED",
        Order: 11,
        Label: "DISC Avanzado",
      },
      RELIABILITY: {
        Name: "RELIABILITY",
        Order: 12,
        Label: "Confiabilidad",
      },
      SAFER: {
        Name: "SAFER",
        Order: 14,
        Label: "Seguridad Laboral",
      },
      QUESTION_FILTER: {
        Name: "QUESTION_FILTER",
        Order: 13,
      },
    },
    TestTypeEnum: {
      PSYCHOMETRIC: {},
      KNOWLEDGE: {},
      INTERVIEW: {},
      CURRICULUM: {},
      DISC: {},
      RELIABILITY: {},
      SAFER: {},
      QUESTION_FILTER: {},
    },
    QuestionSorting: {
      PREDEFINED: {
        Name: "PREDEFINED",
        Label: "Predefinido",
      },
      RANDOM: {
        Name: "RANDOM",
        Label: "Aleatorio",
      },
      DIFFICULTY: {
        Name: "DIFFICULTY",
        Label: "Dificultad",
      },
    },
    AnswerResponseCode: {
      OK: {
        Name: "OK",
        Label: "OK",
      },
      INVALID_STATUS: {
        Name: "INVALID_STATUS",
        Label: "ESTADO INVALIDO",
      },
      OUT_OF_TIME: {
        Name: "OUT_OF_TIME",
        Label: "FUERA DE TIEMPO",
      },
      OPTIMIZED_QUESTION: {
        Name: "OPTIMIZED_QUESTION",
        Label: "PREGUNTA OPTIMIZADA",
      },
    },
    EvaluationConfigType: {
      MONITOR: {
        Name: "MONITOR",
        Label: "MONITOR",
      },
    },
    PersonComponentStatus: {
      PENDING: {
        Name: "PENDING",
        Label: "Sin Iniciar",
      },
      PROCESSING: {
        Name: "PROCESSING",
        Label: "Procesando",
      },
      SUCCESS: {
        Name: "SUCCESS",
        Label: "Finalizado",
      },
      REJECT: {
        Name: "REJECT",
        Label: "Rechazado",
      },
      PENDING_GRADE: {
        Name: "PENDING_GRADE",
        Label: "Por calificar",
      },
    },
    PortfolioScopeEnum: {
      PROCESS: {
        Name: "PROCESS",
        Order: 0,
        Label: "Proceso",
      },
      COMPANY: {
        Name: "COMPANY",
        Order: 1,
        Label: "Empresa",
      },
      GLOBAL: {
        Name: "GLOBAL",
        Order: 2,
        Label: "Global",
      },
    },
    RecomendationTypeEnum: {
      CANDIDATE: {
        Order: 1,
        Label: "Candidato",
      },
      RECRUITER: {
        Order: 2,
      },
    },
    MessageType: {
      REMAINING_TIME: {
        Name: "REMAINING_TIME",
        Label: "'TIEMPO RESTANTE'",
      },
      TIMEOUT: {
        Name: "TIMEOUT",
        Label: "'TIEMPO AGOTADO'",
      },
      CONNECTION_ESTABLISHED: {
        Name: "CONNECTION_ESTABLISHED",
        Label: "'CONEXIÃN ESTABLECIDA'",
      },
      INACTIVITY: {
        Name: "INACTIVITY",
        Label: "'INACTIVIDAD'",
      },
      OUT_OF_DATE: {
        Name: "OUT_OF_DATE",
        Label: "'FUERA DE FECHA'",
      },
      EVALUATION_POSTPONED: {
        Name: "EVALUATION_POSTPONED",
        Label: "'POSPUESTA'",
      },
      FORBIDDEN_SESSION: {
        Name: "FORBIDDEN_SESSION",
        Label: "'SESSION PROHIBIDA'",
      },
      ANOTHER_USER: {
        Name: "ANOTHER_USER",
        Label: "'OTRO USUARIO'",
      },
      CLOSED: {
        Name: "CLOSED",
        Label: "'CERRADO'",
      },
      ALIVE_REMAINING_TIME: {
        Name: "ALIVE_REMAINING_TIME",
        Label: "'TIEMPO RESTANTE'",
      },
    },
    DiscEnum: {
      STRENGTH: {
        ResultType: "STRENGTH",
        Name: "STRENGTH",
        Label: "STRENGTH",
      },
      CLARITY: {
        ResultType: "CLARITY",
        Name: "CLARITY",
        Label: "CLARITY",
      },
      SIMILARITY: {
        ResultType: "SIMILARITY",
        Name: "SIMILARITY",
        Label: "SIMILARITY",
      },
      KEYWORDS: {
        ResultType: "KEYWORDS",
        Name: "KEYWORDS",
        Label: "KEYWORDS",
      },
      ARCHETYPE: {
        ResultType: "ARCHETYPE",
        Name: "ARCHETYPE",
        Label: "ARCHETYPE",
      },
      INTEGRAL: {
        ResultType: "INTEGRAL",
        Name: "INTEGRAL",
        Label: "INTEGRAL",
      },
      PROFESSIONAL: {
        ResultType: "PROFESSIONAL",
        Name: "PROFESSIONAL",
        Label: "PROFESSIONAL",
      },
      RELATIONAL: {
        ResultType: "RELATIONAL",
        Name: "RELATIONAL",
        Label: "RELATIONAL",
      },
      FOCUS: {
        ResultType: "FOCUS",
        Name: "FOCUS",
        Label: "FOCUS",
      },
      TEAM: {
        ResultType: "TEAM",
        Name: "TEAM",
        Label: "TEAM",
      },
      DECISIONS: {
        ResultType: "DECISIONS",
        Name: "DECISIONS",
        Label: "DECISIONS",
      },
      ENERGY: {
        ResultType: "ENERGY",
        Name: "ENERGY",
        Label: "ENERGY",
      },
      D: {
        ResultType: "D",
        Name: "D",
        Label: "D",
      },
      I: {
        ResultType: "I",
        Name: "I",
        Label: "I",
      },
      S: {
        ResultType: "S",
        Name: "S",
        Label: "S",
      },
      C: {
        ResultType: "C",
        Name: "C",
        Label: "C",
      },
    },
    EvaluationStatus: {
      PENDING: {
        Name: "PENDING",
        Label: "SIN INICIAR",
      },
      INPROGRESS: {
        Name: "INPROGRESS",
        Label: "EN PROGRESO",
      },
      COMPLETED: {
        Name: "COMPLETED",
        Label: "COMPLETADO",
      },
      SUSPENDED: {
        Name: "SUSPENDED",
        Label: "SUSPENDIDO",
      },
      RESUMED: {
        Name: "RESUMED",
        Label: "REANUDADO",
      },
      POSTPONED: {
        Name: "POSTPONED",
        Label: "POSPUESTO",
      },
      FINISHED: {
        Name: "FINISHED",
        Label: "FINALIZADA",
      },
      DELETED: {
        Name: "DELETED",
        Label: "ELIMINADA",
      },
      PROCESSING: {
        Name: "PROCESSING",
        Label: "PROCESANDO",
      },
      INTERRUPTED: {
        Name: "INTERRUPTED",
        Label: "INTERRUMPIDO",
      },
      INTERRUPTED_TIMEOUT: {
        Name: "INTERRUPTED_TIMEOUT",
        Label: "'TIEMPO DE INTERRUPCION AGOTADO'",
      },
    },
    FactorInterpretationEnum: {
      TOO_HIGH: {
        Name: "TOO_HIGH",
        Order: 1,
        Label: "Muy Alto",
      },
      HIGH: {
        Name: "HIGH",
        Order: 2,
        Label: "Alto",
      },
      UP_MIDDLE: {
        Name: "UP_MIDDLE",
        Order: 3,
        Label: "Arriba Del TÃ©rmino Medio",
      },
      MIDDLE: {
        Name: "MIDDLE",
        Order: 4,
        Label: "Normal",
      },
      DOWN_MIDDLE: {
        Name: "DOWN_MIDDLE",
        Order: 5,
        Label: "Abajo Del TÃ©rmino Medio",
      },
      LOW: {
        Name: "LOW",
        Order: 6,
        Label: "Bajo",
      },
      TOO_LOW: {
        Name: "TOO_LOW",
        Order: 7,
        Label: "Muy Bajo",
      },
      TOO_RAISED: {
        Name: "TOO_RAISED",
        Order: 8,
        Label: "Muy elevado",
      },
      RAISED: {
        Name: "RAISED",
        Order: 9,
        Label: "Elevado",
      },
      NORMAL: {
        Name: "NORMAL",
        Order: 10,
        Label: "Normal",
      },
      MODERATED: {
        Name: "MODERATED",
        Order: 11,
        Label: "Moderado",
      },
      AVERAGE: {
        Name: "AVERAGE",
        Order: 12,
        Label: "Promedio",
      },
      CLOSE_TO_MIDDLE: {
        Name: "CLOSE_TO_MIDDLE",
        Order: 13,
        Label: "Cercano a la media",
      },
      NULL: {
        Name: "NULL",
        Order: 14,
        Label: "Nulo",
      },
      HIGH_RISK: {
        Name: "HIGH_RISK",
        Order: 15,
        Label: "Riesgo alto",
      },
      MID_RISK: {
        Name: "MID_RISK",
        Order: 16,
        Label: "Riesgo medio",
      },
      LOW_RISK: {
        Name: "LOW_RISK",
        Order: 17,
        Label: "Riesgo bajo",
      },
      ZERO_RISK: {
        Name: "ZERO_RISK",
        Order: 18,
        Label: "Riesgo nulo",
      },
      TOO_HIGH_RISK: {
        Name: "TOO_HIGH_RISK",
        Order: 19,
        Label: "Riesgo Muy Alto",
      },
      MODERATE_RISK: {
        Name: "MODERATE_RISK",
        Order: 20,
        Label: "Riesgo Moderado",
      },
    },
    GapImageEnum: {
      SUPERCAP_GENERAL: {},
      GAP_GENERAL: {},
      COMPETENCE_RADAR: {},
      COMPETENCE_BAR: {},
      COMPETENCE_SCATTER: {},
      GAP_BAR: {},
      TEST_BAR: {},
    },
    CompetenceInterpretationEnum: {
      HIGH_DEVELOPED: {
        Name: "HIGH_DEVELOPED",
        Order: 1,
        Label: "Muy Desarrollado",
      },
      DEVELOPED: {
        Name: "DEVELOPED",
        Order: 2,
        Label: "Desarrollado",
      },
      DEVELOPING: {
        Name: "DEVELOPING",
        Order: 3,
        Label: "En Desarrollo",
      },
      UNDER_DEVELOPED: {
        Name: "UNDER_DEVELOPED",
        Order: 4,
        Label: "Poco Desarrollado",
      },
      LEVEL_O: {
        Name: "LEVEL_O",
        Order: 4,
        Label: "Nivel 0",
      },
    },
    ReportTypeEnum: {
      PDF: {
        MultiPartFile: "PDF",
        Active: true,
        Format: "pdf",
        FileSize: 5120,
      },
      DOCX: {
        MultiPartFile: "DOCX",
        Active: true,
        Format: "docx",
        FileSize: 5120,
      },
      XLS: {
        MultiPartFile: "XLS",
        Active: true,
        Format: "xls",
        FileSize: 5120,
      },
      ZIP: {
        Active: false,
        Format: "zip",
      },
      DOC: {
        MultiPartFile: "DOC",
        Active: true,
        Format: "doc",
        FileSize: 5120,
      },
      PSD: {
        MultiPartFile: "PSD",
        Active: true,
        Format: "psd",
        FileSize: 5120,
      },
      AI: {
        MultiPartFile: "AI",
        Active: true,
        Format: "ai",
        FileSize: 5120,
      },
      CSV: {
        MultiPartFile: "CSV",
        Active: false,
        Format: "csv",
        FileSize: 5120,
      },
      XLSX: {
        MultiPartFile: "XLSX",
        Active: true,
        Format: "xlsx",
        FileSize: 5120,
      },
      PPT: {
        MultiPartFile: "PPT",
        Active: true,
        Format: "ppt",
        FileSize: 5120,
      },
      PPTX: {
        MultiPartFile: "PPTX",
        Active: true,
        Format: "pptx",
        FileSize: 5120,
      },
      JPEG: {
        MultiPartFile: "JPEG",
        Active: true,
        Format: "jpeg",
        FileSize: 5120,
      },
      PNG: {
        MultiPartFile: "PNG",
        Active: true,
        Format: "png",
        FileSize: 5120,
      },
      GIF: {
        MultiPartFile: "GIF",
        Active: true,
        Format: "gif",
        FileSize: 5120,
      },
    },
  },
  PEOPLE: {
    TypeInstitution: {
      SCHOOL: {
        Name: "SCHOOL",
        Label: "Colegio",
      },
      UNIVERSITY: {
        Name: "UNIVERSITY",
        Label: "Universidad",
      },
      INSTITUTE: {
        Name: "INSTITUTE",
        Label: "Instituto",
      },
    },
    InvitedType: {
      USER: {
        Name: "USER",
        Label: "USUARIO",
      },
      CANDIDATE: {
        Name: "CANDIDATE",
        Label: "CANDIDATO",
      },
    },
    MaritalStatus: {
      SINGLE: {
        Name: "SINGLE",
        Label: "SOLTERO/A",
      },
      MARRIED: {
        Name: "MARRIED",
        Label: "CASADO/A",
      },
      DIVORCED: {
        Name: "DIVORCED",
        Label: "DIVORCIADO/A",
      },
      WIDOWER: {
        Name: "WIDOWER",
        Label: "VIUDO/A",
      },
      UNION: {
        Name: "UNION",
        Label: "UNIÓN DE HECHO / CONVIVIENTE",
      },
    },
    Gender: {
      MALE: {
        Name: "MALE",
        Label: "MASCULINO",
      },
      FEMALE: {
        Name: "FEMALE",
        Label: "FEMENINO",
      },
      UNDEFINED: {
        Name: "UNDEFINED",
        Label: "PREFIERO NO DETALLAR",
      },
    },
    StateEducation: {
      FINISHED: {
        Name: "FINISHED",
        Order: 3,
        Label: "TERMINADO",
      },
      COURSING: {
        Name: "COURSING",
        Order: 2,
        Label: "CURSANDO",
      },
      ABANDONED: {
        Name: "ABANDONED",
        Order: 1,
        Label: "ABANDONADO",
      },
    },
    EventInvitationType: {
      CREATE: {
        Name: "CREATE",
        Label: "CREAR",
      },
      CANCEL: {
        Name: "CANCEL",
        Label: "CANCELAR",
      },
    },
    InvitationStatus: {
      PENDING: {
        Name: "PENDING",
        Label: "PENDIENTE",
      },
      ACTIVATED: {
        Name: "ACTIVATED",
        Label: "ACTIVADA",
      },
      CANCELLED: {
        Name: "CANCELLED",
        Label: "CANCELADA",
      },
    },
    TypesCurriculumReferenceRelationships: {
      COWORKER: {
        Name: "COWORKER",
        Label: "Compañero de trabajo",
      },
      MY_BOSS: {
        Name: "MY_BOSS",
        Label: "Mi jefe",
      },
      YOUR_BOSS: {
        Name: "YOUR_BOSS",
        Label: "Su jefe",
      },
    },
    SocialNetworkEnum: {
      LINKEDIN: {
        Name: "LINKEDIN",
        Type: "URL_SITE",
        Order: 1,
        Label: "LINKEDIN",
      },
      FACEBOOK: {
        Name: "FACEBOOK",
        Type: "URL_SITE",
        Order: 2,
        Label: "FACEBOOK",
      },
      TWITTER: {
        Name: "TWITTER",
        Type: "URL_SITE",
        Order: 3,
        Label: "TWITTER",
      },
      GITHUB: {
        Name: "GITHUB",
        Type: "URL_SITE",
        Order: 4,
        Label: "GITHUB",
      },
      YOUTUBE: {
        Name: "YOUTUBE",
        Type: "URL_SITE",
        Order: 5,
        Label: "YOUTUBE",
      },
      INSTAGRAM: {
        Name: "INSTAGRAM",
        Type: "URL_SITE",
        Order: 6,
        Label: "INSTAGRAM",
      },
      PINTEREST: {
        Name: "PINTEREST",
        Type: "URL_SITE",
        Order: 7,
        Label: "PINTEREST",
      },
      SKYPE: {
        Name: "SKYPE",
        Type: "NICK_NAME",
        Order: 8,
        Label: "SKYPE",
      },
      WEBSITE: {
        Name: "WEBSITE",
        Type: "URL_SITE",
        Order: 9,
        Label: "WEBSITE",
      },
    },
    SkillLevel: {
      INDIFFERENT: {
        Factor: 1,
        OrderLevel: 0,
        Name: "INDIFFERENT",
        Label: "Indiferente",
      },
      LOW: {
        Factor: 1,
        OrderLevel: 1,
        Name: "LOW",
        Label: "Bajo",
      },
      MEDIUM: {
        Factor: 2,
        OrderLevel: 2,
        Name: "MEDIUM",
        Label: "Medio",
      },
      HIGH: {
        Factor: 3,
        OrderLevel: 3,
        Name: "HIGH",
        Label: "Alto",
      },
    },
    CompanyTypeEnum: {
      ENTERPRISE: {
        Name: "ENTERPRISE",
        Label: "EMPRESARIAL",
      },
      PYME: {
        Name: "PYME",
        Label: "PYME",
      },
    },
    UserPreferenceType: {
      BOOLEAN: {
        Name: "BOOLEAN",
        Label: "BOOLEAN",
      },
      STRING: {
        Name: "STRING",
        Label: "STRING",
      },
    },
    UserScopeType: {
      COMPANY: {
        Name: "COMPANY",
        Label: "EMPRESA",
      },
      AGENCY: {
        Name: "AGENCY",
        Label: "AGENCIA",
      },
      DEPARTMENT: {
        Name: "DEPARTMENT",
        Label: "DEPARTAMENTO",
      },
    },
    LanguageLevel: {
      ELEMENTARY: {
        OrderLevel: 1,
        Name: "ELEMENTARY",
        Label: "Sin conocimiento",
      },
      LIMITED_WORKING: {
        OrderLevel: 2,
        Name: "LIMITED_WORKING",
        Label: "Básico",
      },
      PROFESSIONAL_WORKING: {
        OrderLevel: 3,
        Name: "PROFESSIONAL_WORKING",
        Label: "Intermedio",
      },
      FULL_PROFESSIONAL: {
        OrderLevel: 4,
        Name: "FULL_PROFESSIONAL",
        Label: "Avanzado",
      },
      NATIVE_OR_BILINGUAL: {
        OrderLevel: 5,
        Name: "NATIVE_OR_BILINGUAL",
        Label: "Nativo",
      },
    },
    FeedbackEventName: {
      FEEDBACK_VIEW: {
        Name: "FEEDBACK_VIEW",
        Label: "Visualizo el Informe",
      },
      FEEDBACK_DOWNLOAD: {
        Name: "FEEDBACK_DOWNLOAD",
        Label: "Descargo el Informe",
      },
      FEEDBACK_EMAIL_SEND: {
        Name: "FEEDBACK_EMAIL_SEND",
        Label: "Envio el Informe por correo",
      },
    },
    ContactInfoEnum: {
      EMAIL: {
        Name: "EMAIL",
        Label: "Mail",
      },
      MOBILE: {
        Name: "MOBILE",
        Label: "Celular",
      },
      HOME: {
        Name: "HOME",
        Label: "Domicilio",
      },
    },
    AccountTypeEnum: {
      PRIMARY: {
        Name: "PRIMARY",
        Label: "PRINCIPAL",
      },
      SECONDARY: {
        Name: "SECONDARY",
        Label: "SECUNDARIA",
      },
    },
    TypePersonCompany: {
      USER_COMPANY: {
        Name: "USER_COMPANY",
        Label: "Usuario de la compañía",
      },
      USER_EVALUAR: {
        Name: "USER_EVALUAR",
        Label: "Usuario evaluar",
      },
      USER_API: {
        Name: "USER_API",
        Label: "Usuario API",
      },
    },
  },
  COMPETENCE: {
    LevelEnum: {
      ESCASO: {
        Name: "ESCASO",
        From: 0,
        Label: "ESCASO",
        To: 2,
      },
      OCASIONAL: {
        Name: "OCASIONAL",
        From: 3,
        Label: "OCASIONAL",
        To: 5,
      },
      FRECUENTE: {
        Name: "FRECUENTE",
        From: 6,
        Label: "FRECUENTE",
        To: 8,
      },
      HABITUAL: {
        Name: "HABITUAL",
        From: 8,
        Label: "HABITUAL",
        To: 10,
      },
    },
    CurriculumSection: {
      PERSONAL_INFO: {
        Name: "PERSONAL_INFO",
        Order: 0,
        Label: "Información personal",
      },
      SALARY: {
        Name: "SALARY",
        Order: 1,
        Label: "Aspiración salarial",
      },
      EDUCATION: {
        Name: "EDUCATION",
        Order: 2,
        Label: "Educación",
      },
      EXPERIENCE: {
        Name: "EXPERIENCE",
        Order: 3,
        Label: "Experiencia profesional",
      },
      LANGUAGE: {
        Name: "LANGUAGE",
        Order: 4,
        Label: "Idiomas",
      },
      SKILL: {
        Name: "SKILL",
        Order: 5,
        Label: "Habilidades / Conocimientos",
      },
      QUESTIONS: {
        Name: "QUESTIONS",
        Order: 6,
        Label: "Preguntas filtro",
      },
      // This enums dont come from the backend has been hardcoded for correct functionality of the CvPage
      REFERENCES: {
        Name: "REFERENCES",
        Order: 7,
        Label: "Referencias laborales",
      },
      MOTIVATORS: {
        Name: "MOTIVATORS",
        Order: 8,
        Label: "Motivadores laborales",
      },
      SOCIAL_NETWORKS: {
        Name: "SOCIAL_NETWORKS",
        Order: 9,
        Label: "Redes sociales",
      },
    },
    UpdateDate: {
      ALL: {
        Name: "ALL",
        Label: "Todas",
      },
      LESS_15_D: {
        Name: "LESS_15_D",
        Label: "Menor a 15 días",
      },
      LESS_1_M: {
        Name: "LESS_1_M",
        Label: "Menor a 1 mes",
      },
      LESS_3_M: {
        Name: "LESS_3_M",
        Label: "Menor a 3 meses",
      },
      LESS_6_M: {
        Name: "LESS_6_M",
        Label: "Menor a 6 meses",
      },
      GREAT_6_M: {
        Name: "GREAT_6_M",
        Label: "Mayor a 6 meses",
      },
    },
    PositionStatus: {
      INACTIVE: {
        Name: "INACTIVE",
        Label: "INACTIVO",
      },
      ACTIVE: {
        Name: "ACTIVE",
        Label: "ACTIVO",
      },
    },
    CurriculumFieldSection: {
      PERSONAL_INFO_AGE: {
        ValidationMessage: "Rango de edad esperado",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_AGE",
        Label: "Edad",
      },
      PERSONAL_INFO_GENDER: {
        ValidationMessage: "Género",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_GENDER",
        Label: "Género",
      },
      PERSONAL_INFO_MARITAL_STATUS: {
        ValidationMessage: "Estado civil",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_MARITAL_STATUS",
        Label: "Estado civil",
      },
      PERSONAL_INFO_RELOCATION: {
        ValidationMessage: "Capacidad de rehubicación",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_RELOCATION",
        Label: "Capacidad de reubicación",
      },
      PERSONAL_INFO_DISABILITY: {
        ValidationMessage: "Discapacidad",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_DISABILITY",
        Label: "Candidato con discapacidad",
      },
      PERSONAL_INFO_CITY: {
        ValidationMessage: "Ciudad",
        CurriculumSection: "PERSONAL_INFO",
        Name: "PERSONAL_INFO_CITY",
        Label: "Ciudad",
      },
      SALARY: {
        ValidationMessage: "Rango Salarial esperado",
        CurriculumSection: "SALARY",
        Name: "SALARY",
        Label: "Salario",
      },
      EDUCATION: {
        ValidationMessage: "Educación",
        CurriculumSection: "EDUCATION",
        Name: "EDUCATION",
        Label: "Educación",
      },
      EXPERIENCE: {
        ValidationMessage: "Experiencia",
        CurriculumSection: "EXPERIENCE",
        Name: "EXPERIENCE",
        Label: "Experiencia laboral",
      },
      LANGUAGE: {
        ValidationMessage: "Lenguages esperados",
        CurriculumSection: "LANGUAGE",
        Name: "LANGUAGE",
        Label: "Idiomas",
      },
      SKILL: {
        ValidationMessage: "Habilidades o Conocimientos requeridos",
        CurriculumSection: "SKILL",
        Name: "SKILL",
        Label: "Habilidades / Conocimientos",
      },
      EXPERIENCE_SUB_AREA: {
        ValidationMessage: "Sub area",
        CurriculumSection: "EXPERIENCE",
        Name: "EXPERIENCE_SUB_AREA",
        Label: "Experiencia Sub Area",
      },
      FILTER_QUESTION: {
        ValidationMessage: "Preguntas Filtro",
        CurriculumSection: "QUESTIONS",
        Name: "FILTER_QUESTION",
        Label: "Preguntas filtro",
      },
    },
    PositionComponentType: {
      TEST: {
        CalcPerTest: false,
        Sections: [],
        CapIncluded: true,
        Name: "TEST",
        Order: 0,
        Label: "PRUEBA COMPETENCIAS",
      },
      COMPETENCE: {
        CalcPerTest: false,
        TestType: "PSYCHOMETRIC",
        Sections: ["INTRO", "COMPETENCES", "GAP", "FACTORS", "COMPETENCE_QUESTION"],
        CapIncluded: true,
        Name: "COMPETENCE",
        Order: 5,
        Label: "COMPETENCIAS",
      },
      KNOWLEDGE_TEST: {
        CalcPerTest: false,
        TestType: "KNOWLEDGE",
        Sections: ["KNOWLEDGE_INTRO", "KNOWLEDGE_QUESTIONS"],
        CapIncluded: true,
        Name: "KNOWLEDGE_TEST",
        Order: 4,
        Label: "CONOCIMIENTO",
      },
      INTERVIEW: {
        CalcPerTest: false,
        TestType: "INTERVIEW",
        Sections: ["INTERVIEW"],
        CapIncluded: true,
        Name: "INTERVIEW",
        Order: 6,
        Label: "VIDEO ENTREVISTA",
      },
      CURRICULUM: {
        CalcPerTest: false,
        TestType: "CURRICULUM",
        Sections: ["CURRICULUM", "FILTER_QUESTIONS"],
        CapIncluded: true,
        Name: "CURRICULUM",
        Order: 3,
        Label: "CURRICULUM",
      },
      DISC: {
        CalcPerTest: true,
        TestType: "DISC",
        Sections: ["DISC", "DISC_ADVANCED"],
        CapIncluded: false,
        Name: "DISC",
        Order: 1,
        Label: "DISC",
      },
      RELIABILITY: {
        CalcPerTest: true,
        TestType: "RELIABILITY",
        Sections: ["RELIABILITY"],
        CapIncluded: false,
        Name: "RELIABILITY",
        Order: 7,
        Label: "CONFIABILIDAD",
      },
      SAFER: {
        CalcPerTest: true,
        TestType: "SAFER",
        Sections: ["SAFER"],
        CapIncluded: false,
        Name: "SAFER",
        Order: 8,
        Label: "SEGURIDAD LABORAL",
      },
      QUESTION_FILTER: {
        CalcPerTest: false,
        TestType: "QUESTION_FILTER",
        Sections: ["QUESTION_FILTER"],
        CapIncluded: false,
        Name: "QUESTION_FILTER",
        Order: 2,
        Label: "PREGUNTAS FILTRO",
      },
    },
    PositionOrigin: {
      ORIGINAL: {
        Name: "ORIGINAL",
        Label: "ORIGINAL",
      },
      IMPORTED: {
        Name: "IMPORTED",
        Label: "IMPORTADO",
      },
      MODIFIED: {
        Name: "MODIFIED",
        Label: "MODIFICADO",
      },
    },
    FactorsReuse: {
      NOT_REUSE: {
        Name: "NOT_REUSE",
        Label: "No reutilizar",
      },
      REUSE: {
        Name: "REUSE",
        Label: "Reutilizar",
      },
      EVALUATED_CHOICE: {
        Name: "EVALUATED_CHOICE",
        Label: "Candidato decide",
      },
    },
    Difficulty: {
      EASY: {
        Name: "EASY",
        Order: 0,
        Label: "BAJO",
      },
      MEDIUM: {
        Name: "MEDIUM",
        Order: 1,
        Label: "MEDIO",
      },
      HARD: {
        Name: "HARD",
        Order: 2,
        Label: "ALTO",
      },
    },
  },
} as const;
export default evEnums;
